export default __webpack_public_path__ + "static/media/14.c375f517.jpg";